export const programCompareTags = ["ProgramCompare"] as const;

export interface ProgramCompareItem {
    user_id: number;
    name: string | null;
    surname: string | null;
    member_fee_at: string | null;
    star_pay_at: string | null;
    diff_days: number | null;
}

export interface ProgramCompareStats {
    ok_aligned: number;
    misaligned_gt5: number;
}

export interface ProgramCompareMeta {
    current_page: number;
    per_page: number;
    total: number;
    last_page: number;
}

export interface ProgramCompareResponse {
    success: boolean;
    data: ProgramCompareItem[];
    meta: ProgramCompareMeta;
    stats: ProgramCompareStats;
}

export interface UpdateStarPayDateResponse {
    success: boolean;
    message: string;
    data: {
        user_id: number;
        star_pay_at: string | null;
    };
}

export interface ProgramCompareParams {
    page?: number;
    per_page?: number;
    user_id?: number;
    sort_by?: "diff_days" | "member_fee_at" | "star_pay_at" | "user_id";
    sort_order?: "asc" | "desc";
}

export const programCompareEndpoints = {
    getProgramCompare: {
        query: (params: ProgramCompareParams | void) => ({
            url: "/admin/programs/payment-compare",
            params: params ?? {},
        }),
        providesTags: programCompareTags,
    },
    updateStarPayDate: {
        query: (params: { userId: number; user_pay_date: string | null }) => ({
            url: `/admin/programs/payment-compare/${params.userId}/star-pay-date`,
            method: "PATCH",
            body: { user_pay_date: params.user_pay_date },
        }),
        invalidatesTags: programCompareTags,
    },
};

